import { useEffect } from 'react';
import Hero from '../../components/HomepageComponents/Hero';
import Section2 from '../../components/HomepageComponents/Section2';
import Section3 from '../../components/HomepageComponents/Section3';
import Section4 from '../../components/HomepageComponents/Section4';
import Section5 from '../../components/HomepageComponents/Section5';
import Section6 from '../../components/HomepageComponents/Section6';
import Section7 from '../../components/HomepageComponents/Section7';
import Section8 from '../../components/HomepageComponents/Section8';

const Home = () => {
  useEffect(() => {
    const lang = localStorage.getItem("i18nextLng");
    if (!lang || lang === "en-US") {
      localStorage.setItem("i18nextLng", "en");
      window.location.reload();
    };

    // Set the meta title and description dynamically
    document.title = "Best Tutoring Platform - Nadwa in UAE, UK, and US";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute("content", "Nadwa is the best tutoring platform available in the UAE, UK, and US, providing top-notch education and personalized tutoring services.");
    } else {
      const newMetaDescription = document.createElement('meta');
      newMetaDescription.name = 'description';
      newMetaDescription.content = "Nadwa is the best tutoring platform available in the UAE, UK, and US, providing top-notch education and personalized tutoring services.";
      document.head.appendChild(newMetaDescription);
    }
  }, []);

  return (
    <div>
      <Hero />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
      <Section8 />
    </div>
  );
};

export default Home;

